import {ArrowDownward, Check, Close} from "@mui/icons-material"
import {deleteArticleNoteRelationFromIcon} from "../../../reducers/workspaceNoteSlice"
import {useDispatch} from "react-redux"
import useHover from "../../../hooks/useOnHover"
import {
	Box,
	Fade,
	//Fade,
	IconButton
} from "@mui/material"
//import {TransitionGroup} from "react-transition-group"
import {useEffect, useState} from "react"
import {NOTE_ARTICLE_RELATIONSHIP} from "./NoteTreeV2"

export default function NoteArticleRelationsIcon({note, articleRelationship}) {
	const dispatch = useDispatch()
	const [hoverRef, isHovered] = useHover()
	const [transition, setTransition] = useState(false)

	const handleCheckIconClick = () => {
		dispatch(deleteArticleNoteRelationFromIcon(note))
	}

	useEffect(() => {
		let timer
		if(isHovered && !transition){
			timer = setTimeout(() => {
				setTransition(true)
			}, 300)
		}

		if(!isHovered) {
			clearTimeout(timer)
			setTransition(false)
		}

		return () => {
			clearTimeout(timer)
		}
	}, [isHovered])

	return (
		<Box
			// component="span"
			sx={{
				minWidth: "34px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexShrink: 0,
			}}
		>
			<Fade
				in={
					articleRelationship === NOTE_ARTICLE_RELATIONSHIP.ATTACHED
					|| articleRelationship === NOTE_ARTICLE_RELATIONSHIP.RELATED && !note?.showChildren
				}
				appear
				unmountOnExit
			>
				{/* span tag here prevents known MUI issue resulting in a crash when
				inner component is empty.
				Yes, it has to be here and not in the child component*/}
				<span
					style={{
						flex: 1,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						height: "100%",
					}}
				>
					{articleRelationship === NOTE_ARTICLE_RELATIONSHIP.RELATED && !note?.showChildren && (
						<ArrowDownward
							sx={{
								color: "blue",
								fontSize: "20px",
								position: "relative"
							}}
						/>
					)}
					{ articleRelationship === NOTE_ARTICLE_RELATIONSHIP.ATTACHED && (
						<IconButton
							sx={{
								fontSize: "20px",
							}}
							ref={hoverRef}
						>
							{ transition ?
								<Close
									sx={{
										cursor: "pointer",
										color: "red",
									}}
									onClick={handleCheckIconClick}
								/>
								:
								<Check
									sx={{
										color: "green",
									}}
								/>
							}
						</IconButton>
					)}
				</span>
			</Fade>
		</Box>
	)
}